export const SYSTEM_MESSAGE_SHOW = 'SYSTEM_MESSAGE_SHOW'
export const SYSTEM_MESSAGE_CANCELED = 'SYSTEM_MESSAGE_CANCELED'

export const SYSTEM_MESSAGE_ACTION = {
  content: '',
  icon: null,
  onClick: null,
}

export const SYSTEM_MESSAGE_INITIAL_STATE = {
  cancelable: true,
  msg: '',
  options: [],
  show: false,
  title: '',
}

export const systemMessageShow = (payload) => ({
  payload,
  type: SYSTEM_MESSAGE_SHOW,
})
export const systemMessageCanceled = () => ({
  payload: null,
  type: SYSTEM_MESSAGE_CANCELED,
})
